import { useQuery } from '@tanstack/react-query';
import { REFRESH_INTERVALS } from '../constants';

export type GridStatus = 'normal' | 'watch' | 'warning' | 'load_shedding';

export interface GridStatusData {
  status: GridStatus;
  isActive: boolean;
  alertMessages: string[];
  messageText: string | null;
  recordedAt: string | null;
}

export function useGridStatus() {
  return useQuery({
    queryKey: ['grid-status', 'current'],
    queryFn: async (): Promise<GridStatusData> => {
      const response = await fetch('/api/grid-status/current');
      if (!response.ok) {
        throw new Error('Failed to fetch grid status');
      }
      return response.json();
    },
    refetchInterval: REFRESH_INTERVALS.current,
  });
}

// Keep old hook for backward compatibility
export function useLoadShedding() {
  return useGridStatus();
}
